import { t as createFusedQrPoseTracker } from "../../qr-fused-pose-1kcr85X6.js";
//#region ../src/ar/qr/qr-fused-pose-source.ts
function createFusedQrPoseSource(config) {
	const now = () => config.now ? config.now() : performance.now();
	const trackers = /* @__PURE__ */ new Map();
	const results = /* @__PURE__ */ new Map();
	const trackerFor = (text) => {
		let tracker = trackers.get(text);
		if (!tracker) {
			tracker = createFusedQrPoseTracker(config.optionsFor?.(text) ?? {});
			trackers.set(text, tracker);
		}
		return tracker;
	};
	const evaluate = (text) => {
		const t0 = now();
		const result = trackerFor(text).evaluate(config.entriesOf(text));
		if (result !== results.get(text)) config.onEvaluated?.(result, now() - t0, text);
		results.set(text, result);
		return result;
	};
	return {
		evaluate,
		resolve(text) {
			const result = evaluate(text);
			return result.status === "stable" ? result.pose : null;
		},
		last(text) {
			return results.get(text) ?? null;
		}
	};
}
//#endregion
export { createFusedQrPoseSource };
